module.exports = __webpack_public_path__ + "img/logo_dark_bg_medium.4c1d5e58.png";